module.exports = __webpack_public_path__ + "components/rewards/vista-tours/static/logo-51b412b5b06d95696dfeecde6561ed48.webp";